import api from '@/utils/api';
import { env } from '@/config/env';

interface SystemConfigResponse {
  success: boolean;
  config: {
    mode: {
      isManaged: boolean;
      isStandalone: boolean;
      tenantMode: string;
    };
    licenseMode?: {
      isOnline: boolean;
      isOffline: boolean;
      mode: 'online' | 'offline';
    };
  };
}

/**
 * Fetch system configuration from backend
 * This includes mode (managed/standalone) and license mode
 */
export const fetchSystemConfig = async (): Promise<void> => {
  try {
    const response = await api.get<SystemConfigResponse>('/system/config');

    if (response.success && response.config) {
      // Update env with backend configuration
      env._updateModeConfig(response.config);
    }
  } catch (error) {
    console.error('[SystemConfig] Failed to fetch system configuration:', error);
    // Keep default values (false) if fetch fails
  }
};

/**
 * Initialize system configuration
 * Should be called once on app initialization
 */
export const initializeSystemConfig = async (): Promise<void> => {
  await fetchSystemConfig();
};
